import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import Graphic from '@arcgis/core/Graphic';

import { ConfigService } from '../../../../_services/local/config.service';
import { ISagtFeature } from '../../../../_models/SagtFeature';
import { ILayerFilterConfig } from 'src/app/_models/ApplicationConfig';

@Component({
  selector: 'app-tab-geometry',
  templateUrl: './tab-geometry.component.html',
  styleUrls: ['./tab-geometry.component.scss'],
})
export class TabGeometryComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() isReadOnly: boolean = true;

  public height = document.body.clientHeight * 0.8 - (48 + 48 + 16 + 40);
  public currentGraphics!: Graphic[];
  public filterLayer: ILayerFilterConfig | null = null;

  constructor(public configService: ConfigService) {}

  ngOnInit(): void {
    const features = this.form.get('features')?.value as Graphic[];
    if (features && features.length > 0) {
      this.currentGraphics = features;
    }

    this.filterLayer = {
      url: this.configService.Config.filterLayers.sp.url,
      layerIds: this.configService.Config.filterLayers.sp.layerIds,
      definitionExpression: this.form?.get('id')?.value
        ? `${this.configService.Config.filterLayers.sp.field} = ${this.form.get('id')?.value}`
        : undefined,
    };
  }

  featuresChanges(features: ISagtFeature[]): void {
    console.debug(features);
    this.form.get('features')?.setValue(features);
    this.form.markAsDirty();
  }
}
